<template>
  <BaseModal
    :model-value="modelValue"
    class="p-2 pt-4 md:p-4 md:pt-8 gap-0 !rounded-2xl w-[96vw] md:w-[640px] !max-w-[none] max-h-[96vh] md:max-h-[90%] h-auto"
    @update:model-value="updateModelValue"
  >
    <!-- Content (with higher z-index) -->
    <template #header>
      <div class="pr-20">
        <h1 class="text-lavender text-4xl md:text-[56px] leading-8 md:leading-10 font-normal tracking-[-1.28px] select-none">
          How it works?
        </h1>
      </div>
    </template>
    <AccordionRoot
      type="single"
      collapsible
      default-value="1. Generate Power"
      class="flex flex-col z-10 w-full gap-1 mt-8"
    >
      <AccordionItem
        v-for="(item, index) in faqItems"
        :key="index"
        :value="item.question"
        class="border-none cursor-pointer"
      >
        <div
          :style="item.style"
          :class="item.questionBgClass"
          class="rounded-2xl inset-shadow-[0_-4px_16px_-2px_rgba(222,206,235,0.08)] bg-[rgba(38,38,56,0.32)] p-4"
        >
          <AccordionTrigger class="cursor-pointer outline-none py-2">
            <span class="text-lavender text-2xl md:text-[40px] leading-8 md:leading-10 font-normal tracking-[-2px]">
              {{ item.question }}
            </span>
            <template #icon>
              <InlineSvg
                :src="chevronIcon"
                class="size-6 md:size-10"
                unique-ids="chevron-icon"
              />
            </template>
          </AccordionTrigger>
          <AccordionContent>
            <component :is="item.answer" />
          </AccordionContent>
        </div>
      </AccordionItem>
    </AccordionRoot>
    <template #footer>
      <div class="p-8 pt-0 w-full flex justify-center mt-4 md:mt-9">
        <ButtonWithAnimation
          :color="EButtonColor.ORANGE"
          @click="updateModelValue(false)"
        >
          <span> Let's Go! </span>
        </ButtonWithAnimation>
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/ui/dialog/BaseModal.vue'
import { AccordionContent, AccordionItem, AccordionRoot, AccordionTrigger } from '@/components/ui/accordion'
import chevronIcon from '@/assets/icons/rounded-chevron.svg'
import asteroidIcon from '@/assets/images/asteroid.png'
import giftBoxIcon from '@/assets/images/gift-box.png'
import question1Bg from '@/assets/images/faq/question-1.png'
import question2Bg from '@/assets/images/faq/question-2.png'
import question3Bg from '@/assets/images/faq/question-3.png'
import powerIcon from '@/assets/images/bolt.svg'
import InlineSvg from 'vue-inline-svg'
import FirstSection from './FirstSection.vue'
import SecondSection from './SecondSection.vue'
import ThirdSection from './ThirdSection.vue'
import { EButtonColor } from '@/types/shared/button'
import ButtonWithAnimation from '../ui/button/ButtonWithAnimation.vue'

defineProps<{
	modelValue: boolean
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
}>()

const updateModelValue = (val: boolean) => {
  emit('update:modelValue', val)
}

const faqItems = [
  {
    question: '1. Generate Power',
    style: `background-image: url(${powerIcon}), url(${question1Bg})`,
    questionBgClass: `bg-no-repeat bg-[40px_40px,680px_240px] bg-[calc(137px_+_30px)_22px,top] md:bg-[calc(50%_+_4px)_30px,top]`,
    answer: FirstSection,
  },
  {
    question: '2. Play & Earn',
    style: `background-image: url(${asteroidIcon}), url(${question2Bg})`,
    questionBgClass: `bg-no-repeat bg-[174px_106.5px,680px_240px] bg-[calc(137px_-_70px)_0px,top] md:bg-[calc(50%_-_60px)_0px,top]`,
    answer: SecondSection,
  },
  {
    question: '3. Win Big Prizes ',
    style: `background-image: url(${giftBoxIcon}), url(${question3Bg})`,
    questionBgClass: `bg-no-repeat bg-[48px_47px,680px_240px] bg-[calc(137px_+_0px)_14px,top] md:bg-[calc(50%_-_35px)_21px,top]`,
    answer: ThirdSection,
  },
]
</script>
